import { createAction } from 'redux-actions';

export const updateUser = createAction('UPDATE_USER');
export const updateUserFailure = createAction('UPDATE_USER_FAILURE');
export const updateUserSuccess = createAction('UPDATE_USER_SUCCESS');

export const getUser = createAction('GET_USER');
export const getUserSuccess = createAction('GET_USER_SUCCESS');
export const getUserFailure = createAction('GET_USER_FAILURE');
